import { inject, observer } from "mobx-react";
import AgGrid from "../../../common/components/ag-grid/ag-grid";
import { AppConstants } from "../../../common/APIConstants";
import React from "react";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileExport,
  faSave,
  faSync,
  faExpandAlt,
  faCompressAlt,
  faTrashRestore,
  faPlusCircle,
} from "@fortawesome/free-solid-svg-icons";
import '../component/sox-audit-screen-component.scss';
import { Button, ButtonGroup, Dropdown, Form, DropdownButton,Modal } from 'react-bootstrap';
import RestEndPoint from '../../../common/RestEndPoint';
import LeaseMasterChangeService from '../services/lease-master-changes-service';
import userRoles from '../../../constants/userRoles';

// Gneral Focus Hook
const utilizeFocus = () => {
	const ref = React.createRef()
	const setFocus = () => {ref.current &&  ref.current.focus()}

	return {setFocus, ref} 
}


@inject("LeaseMasterPriceChangeStore", "AuthStore", "CommonStore")
@observer
class LeaseMasterPriceChangeComponent extends React.Component {
  constructor(props) {
    super(props);

    this.inputFocus = utilizeFocus();
    this.state = {
      commentData:'',
      commentPopup:false,
      isSOXAuditMarketingRepRole: false,
      isSOXAuditPricingAdminRole: false,
      selectedRowsByUserRole: [],
      loggedInUser: '',
      isDirectRoute: this.props.computedMatch.params.profile,
      userView: JSON.parse(window.localStorage.getItem('userView')) || 'MR',
      isExpand: true,
      gridOptions: {
        rowClassRules: {
          // row style function
          'lease-approved-changes': function (params) {
            if (params.data !== undefined) {
              return params.data.ApprovalStatus === 'Approved';
            }
          },
          'lease-rejected-changes': function (params) {
            if (params.data !== undefined) {
              return params.data.ApprovalStatus === 'Rejected';
            }
          },
          
        },
        defaultColDef: {
          flex: 1,
          minWidth: 50,
          enableValue: true,
          sortable: true,
          filter: true,
          resizable: true,
          enablePivot: true,
        },
        autoGroupColumnDef: {
          headerCheckboxSelection: true,
          cellRenderer: 'agGroupCellRenderer',
          cellRendererParams: {
            checkbox: this.checkbox,
          },
          minWidth: 550
        },
        rowSelection: 'multiple',
        groupSelectsChildren: true,
        suppressRowClickSelection: true,
        suppressAggFuncInHeader: false,
        stopEditingWhenGridLosesFocus: true,
        autoSizeAllColumns: true,
        groupDefaultExpanded: -1,
        rowGroupPanelShow: 'always',
        groupDisplayType: 'singleColumn',
        onRowClicked(params) {
          params.node.setExpanded(!params.node.expanded);
        },
        statusBar: {
          statusPanels: [
            {
              statusPanel: "agTotalAndFilteredRowCountComponent",
              align: "left",
            },
            {
              statusPanel: "agAggregationComponent",
              statusPanelParams: {
                aggFuncs: ["avg", "count", "min", "max", "sum"],
              },
            },
          ],
        },
        sideBar: {
          toolPanels: [
            {
              id: "columns",
              labelDefault: "Columns",
              labelKey: "columns",
              iconKey: "columns",
              toolPanel: "agColumnsToolPanel",
            },
          ],
          showToolPanel: false,
        }
      },
    };
  }

  componentDidMount(){
    this.inputFocus.setFocus();
  }
  
  componentDidUpdate(){
    this.inputFocus.setFocus();
  }

  checkbox = (params) => {
    return params.node.group === true;
  }

  reSelect = () => {
    const selectedRows = JSON.parse(localStorage.getItem("selectedRows"));
    this.state.gridOptions.api.forEachNode((node) => {
      // adapt with you own unique role-id rule
      if (node && node.data && selectedRows) {
        const selectNode = selectedRows.some((row) => { return row.ID === node.data.ID });
        if (selectNode) {
          node.setSelected(true, false);
        }
      }
    });
  };

  commentPopup = async ()=>{
    let selectedRows = this.state.gridOptions.api.getSelectedRows();
    let id = selectedRows.map((foo) => foo.ID);
    let apstatus = selectedRows.map((foo) => foo.ApprovalStatus);
    
    if(Object.keys(id).length > 0){
      /* if checked only one then below condition will apply */
      if(Object.keys(id).length==1 && apstatus[0]=='Rejected')
        alert('Comments can not be added to rejected changes');
      else{
        //Popup open
        this.setState({commentPopup:true});
      }
    }else{
      alert('Kindly select atleast anyone')
    }
  }

  closeCommentPopup = ()=>{
    this.setState({commentPopup:false});
  }

  addCommentButton = async ()=>{
    let comment = this.state.commentData
    let l = (comment).length;
    let selectedRows = this.state.gridOptions.api.getSelectedRows();
    let rejected_selected = this.state.gridOptions.api.getSelectedRows();

    selectedRows = selectedRows
    .filter(f => f.ApprovalStatus !== 'Rejected')
    
    let id = selectedRows
      .filter(f => f.ApprovalStatus !== 'Rejected')
      .map((foo) => foo.ID); 

    let reject_id = rejected_selected
    .filter(f => f.ApprovalStatus === 'Rejected')
    .map((foo) => foo.ID);

    const currentScreen = this.getCurrentScreen();
    if(l==0)
      alert('Enter your comment');
    else if(l>60)
      alert('Enter only 60 characters');
    else if(id.length==0)
      alert("Kindly select atleast anyone and don't select rejected status");
    else if(comment!='' && id!=''){
      const { CommonStore, LeaseMasterPriceChangeStore } = this.props;
      const currentUser = RestEndPoint.getCurrentUserName();
      let returnData = await LeaseMasterPriceChangeStore.addComment(id,comment,CommonStore,1,(currentScreen.screen.name));
      if(returnData.status){

        if(reject_id.length>0)
          window.toastr.success("Comments Saved Sucessfully! and Comments can not be added to rejected changes");
        else
          window.toastr.success("Comments Saved Sucessfully!");
        
        this.closeCommentPopup();
        /* Update in AG GRID */
        selectedRows.forEach(element => {
          element.Comment = comment;
          //element.UpdatedBy = currentUser;
          //element.UpdatedOn = moment(new Date()).tz('America/Chicago').format('YYYY-MM-DD HH:mm');
        })
        //await this.saveScreenData(selectedRows);
        await this.refreshData();
        //window.location.reload();
      }else{
        window.toastr.error(returnData.message);
      }
    }
  }

  removeComment = async ()=>{
    let comment = this.state.commentData
    let l = (comment).length;
    let selectedRows = this.state.gridOptions.api.getSelectedRows();
    let id = selectedRows.map((foo) => foo.ID); 
    const currentScreen = this.getCurrentScreen();
    
    if(id.length==0)
      alert('Kindly select atleast anyone');
    else{

      if(window.confirm('Are you sure want to remove comment?')){
        const { CommonStore, LeaseMasterPriceChangeStore } = this.props;
        const currentUser = RestEndPoint.getCurrentUserName();
        let returnData = await LeaseMasterPriceChangeStore.addComment(id,'',CommonStore,2,(currentScreen.screen.name));
        if(returnData.status){
          window.toastr.success("Comments Removed Sucessfully!");
          this.closeCommentPopup();
          /* Update in AG GRID */
          selectedRows.forEach(element => {
            element.Comment = '';
            //element.UpdatedBy = currentUser;
            //element.UpdatedOn = moment(new Date()).tz('America/Chicago').format('YYYY-MM-DD HH:mm');
          })
          //await this.saveScreenData(selectedRows);

          
          await this.refreshData();
          //window.location.reload();
        }else{
          window.toastr.error(returnData.message);
        }
      }
    }
  }
  
  approveChanges = async () => {
    const selectedRows = this.state.gridOptions.api.getSelectedRows();
    selectedRows.forEach(element => {
      element.ApprovalStatus = "Approved";
    })
    
    await this.saveScreenData(selectedRows);
  }

  saveScreenData = async (screenData) => {
    const { CommonStore, LeaseMasterPriceChangeStore } = this.props;
    const currentUser = RestEndPoint.getCurrentUserName();
    const currentScreen = this.getCurrentScreen();
    if(screenData.length) {
      screenData.forEach(element => {
        element.UpdatedBy = currentUser;
        element.UpdatedOn = moment(new Date()).tz('America/Chicago').format('YYYY-MM-DD HH:mm');
      })
      await LeaseMasterPriceChangeStore.saveScreenData(
        screenData,
        CommonStore,
        currentScreen
      );
      await this.refreshData();
    }
    else
    window.toastr.error("No changes to save"); 
  };

  rejectChanges = async () => {
    const selectedRows = this.state.gridOptions.api.getSelectedRows();
    selectedRows.forEach(element => {
      element.ApprovalStatus = "Rejected"
      element.Comment = ""
    })
    await this.saveScreenData(selectedRows);
  }

  expandCollapseAll = () => {
    const { gridOptions, isExpand } = this.state;
    isExpand ? gridOptions.api.collapseAll() : gridOptions.api.expandAll();
    gridOptions.columnApi.autoSizeAllColumns();
    this.setState({isExpand: !isExpand});
  }

  onChangeUserView = (event) => {
    const { name, value } = event.target;
    this.setState({ userView: value });
    window.localStorage.setItem('userView', JSON.stringify(value));
    this.filterViewData(value);
    this.addMarketingRepGroup(value !== 'MR');
    }

  filterViewData = (value) => {
    const { rowData, marketingRepList } = this.props.LeaseMasterPriceChangeStore;
    const { loggedInUser } = this.state;
    let getMarketingRepIds = []
    if (value === 'MR') {
      getMarketingRepIds = marketingRepList.filter(data => data.marketingRepEmailID?.toLowerCase() === loggedInUser?.toLowerCase()).map(a => { return a.marketingRepID; });
    } else if (value === 'Alternate') {
      getMarketingRepIds = marketingRepList.filter(data => data.alternateUserEmailID?.toLowerCase() === loggedInUser?.toLowerCase()).map(a => { return a.marketingRepID; });
    } else if (value === 'EscalationUser1') {
      getMarketingRepIds = marketingRepList.filter(data => data.escalationUser1EmailID?.toLowerCase() === loggedInUser?.toLowerCase()).map(a => { return a.marketingRepID; });
    } else if (value === 'EscalationUser2') {
      getMarketingRepIds = marketingRepList.filter(data => (data.escalationUser2AEmailID?.toLowerCase() === loggedInUser?.toLowerCase()) || (data.escalationUser2BEmailID?.toLowerCase() === loggedInUser?.toLowerCase())).map(a => { return a.marketingRepID; });
    }
    const filteredRows = value === "Admin" ? rowData : rowData.filter(data => getMarketingRepIds.includes(Number(data.MarketingRepID)));
    this.setState({ selectedRowsByUserRole: filteredRows });
    this.state.gridOptions.columnApi.autoSizeAllColumns();
  }

  addMarketingRepGroup = (group) => {
    const {columnApi} = this.state.gridOptions;
    const currentScreen = this.getCurrentScreen();
    
    if (currentScreen.screen.name == "SOXLeasePricing") {
      columnApi.removeRowGroupColumns(['MarketingRepName','OperatorName','ContractName','EffectiveDate','ChangeTextLineGroup','ContractPartner']);
      if (group) {
        columnApi.addRowGroupColumns(['MarketingRepName','ContractPartner','OperatorName','ContractName','EffectiveDate','ChangeTextLineGroup']);
      } 
      else {
      //console.log('inside screen name',currentScreen.screen.name);
      columnApi.addRowGroupColumns(['ContractPartner','OperatorName','ContractName','EffectiveDate','ChangeTextLineGroup']);
      }
    }
    else if (currentScreen.screen.name == "SOXContractPricing") {
      columnApi.removeRowGroupColumns(['MarketingRepName','ContractPartner','ContractName','ChangeType','DeliveryRowGroup','EffectiveDate']);
      if (group) {
        columnApi.addRowGroupColumns(['MarketingRepName','ContractPartner','ContractName','ChangeType','DeliveryRowGroup','EffectiveDate']);
      } 
      else {
        columnApi.addRowGroupColumns(['ContractPartner','ContractName','ChangeType','DeliveryRowGroup','EffectiveDate']);
      }
    }

    columnApi.autoSizeAllColumns();
  }

  render() {
    const {
      approveBtnText,
      rejectBtnText,
      exportBtnText,
      refreshBtnText,
      saveProfileText,
      resetProfileText,
      columnDefinitions
    } = this.props.LeaseMasterPriceChangeStore;
    const {
      screen: { title },
    } = this.getCurrentScreen();
    const currentScreen = this.getCurrentScreen();
    const { gridOptions, isSOXAuditMarketingRepRole, isSOXAuditPricingAdminRole, selectedRowsByUserRole, userView, isExpand } = this.state;
    
    const commentButton = () => {
      //if (currentScreen.screen.name == "SOXLeasePricing") {
        return (
        <>
          <button
            type="button"
            className="btn btn-primary btn-grid"
            aria-expanded="false"
            onClick={this.commentPopup}
            disabled={!isSOXAuditMarketingRepRole || userView == "Admin"}
          >
            <FontAwesomeIcon icon={faPlusCircle} /> Add Comment
          </button>

          <button
            type="button"
            className="btn btn-primary btn-grid"
            aria-expanded="false"
            onClick={this.removeComment}
            disabled={!isSOXAuditMarketingRepRole || userView == "Admin"}
          >
            <FontAwesomeIcon icon={faTrashRestore} /> Remove Comment
          </button>
        </>
        )
      //} 
    }


    return (
      <>
      <Modal show={this.state.commentPopup} >
        <Modal.Header className="otgmodel-header" >
          <Modal.Title>Add Comment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <textarea  className="form-control" onChange={(e)=>{
            this.setState({commentData: e.target.value})
          }} placeholder="[Enter Comment Here]"
          ref={this.inputFocus.ref}
          row="5"></textarea>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-primary btn-grid"
            aria-expanded="false"
            onClick={this.addCommentButton}
          >
            Save
          </button>
          <button
            type="button"
            className="btn btn-primary btn-grid"
            aria-expanded="false"
            onClick={this.closeCommentPopup}
          >
            Cancel
          </button>
        </Modal.Footer>
      </Modal>
      <div className="col-md-12">
        <div className="container cb-title-container">
          <h3 className="cb-title">{title}</h3>
        </div>
        {(
          <div className="sox-grid-div">
            <div className="row">
              <AgGrid
                gridOptions={gridOptions}
                columnDefs={columnDefinitions}
                rowData={selectedRowsByUserRole}
                rememberGroupStateWhenNewData={true}
                onSelectionChanged={this.onSelectionChanged}
              />
            </div>
            <div className="row btn-toolbar pull-left customExportPnl">
              
              <button
                type="button"
                className="btn btn-primary btn-grid"
                aria-expanded="false"
                disabled={!isSOXAuditMarketingRepRole || userView == "Admin"}
                onClick={this.approveChanges}
              >
                <FontAwesomeIcon icon={faSave} /> {approveBtnText}
              </button>
              <button
                type="button"
                className="btn btn-primary btn-grid"
                aria-expanded="false"
                disabled={!isSOXAuditMarketingRepRole || userView == "Admin"}
                onClick={this.rejectChanges}
              >
                <FontAwesomeIcon icon={faSave} /> {rejectBtnText}
              </button>

              <button
                type="button"
                className="btn btn-primary btn-grid"
                style={{width:60}}
                aria-expanded="false"
                onClick={this.expandCollapseAll}
              >
              {isExpand ? <FontAwesomeIcon icon={faCompressAlt} /> : <FontAwesomeIcon icon={faExpandAlt}/>}
              </button>

              {commentButton()}

            </div>
            <div className="row btn-toolbar pull-right">
              <Form.Select onChange={this.onChangeUserView} value={userView} style={{width:150}}>
                <option value="MR"> Marketing Rep </option>
                <option value="Alternate"> Alternate User </option>
                <option value="EscalationUser1"> Escalation User1 </option>
                <option value="EscalationUser2"> Escalation User2 </option>
                {isSOXAuditPricingAdminRole && <option value="Admin"> Admin </option>}
              </Form.Select>

              <DropdownButton as={ButtonGroup} drop="up" style={{marginLeft:"5px",width:"80px"}}>
                <Dropdown.Item as={Button} onClick={this.saveProfile}>{saveProfileText}</Dropdown.Item>
                <Dropdown.Item as={Button} onClick={this.resetProfile}>{resetProfileText}</Dropdown.Item>
                <Dropdown.Item as={Button} onClick={this.refreshData}>{refreshBtnText}</Dropdown.Item>
                <Dropdown.Item as={Button} onClick={this.exportToExcel}>{exportBtnText}</Dropdown.Item>
              </DropdownButton>
            </div>
          </div>
        )}
      </div>
    </>
      
    );
  }

  componentWillMount = async () => {
    const { CommonStore } = this.props;
    //var directURLParam = this.props.computedMatch.params.profile;

    if(!CommonStore.screenDetails.length)
    await CommonStore.getScreens();

    if (this.state.isDirectRoute) {
      CommonStore.toggleLoader();
      CommonStore.getScreens().then(async () => {
        await this.getScreenData();
        await this.getProfile();
        CommonStore.toggleLoader();
      }).catch(() => {
        window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
        CommonStore.toggleLoader();
      })
    }
    else {
      await this.getScreenData();
      await this.getProfile();
    }
  };

  exportToExcel = () => {
    const currentScreen = this.getCurrentScreen();
    var today = new Date();
    const formattedDate = moment(today).format('YYYYMMDDhhmmss');
    const currentSheet = currentScreen.screen.title.split(' ').join('_');
    let fileNameExcelExport = currentSheet + '_Export_All_' + formattedDate + '';
    this.state.gridOptions.api.exportDataAsExcel({
      fileName: fileNameExcelExport,
      sheetName: currentSheet,
      columnKeys: this.generateColumnsForCustomExcel(),
      processCellCallback: function (params) {
        if (params.column.colDef.cellRenderer === "booleanTextFormatter") {
          var value = params.value;
          return (value && value === true) ? "Yes" : "No";
        }
        return params.value;
      }
    })
  };

  generateColumnsForCustomExcel() {
    this.state.gridOptions.columnApi.getAllDisplayedColumns().map(column => column.getColId());
  }

  saveProfile = () => {
    let reqBody = {};
    let columnState = this.state.gridOptions.columnApi.getColumnState();
    let sortState = this.state.gridOptions.api.getSortModel();
    let filterState = this.state.gridOptions.api.getFilterModel();
    let currentScreen = this.getCurrentScreen();

    reqBody.FilterState = JSON.stringify(filterState);
    reqBody.ColumnState = JSON.stringify(columnState);
    reqBody.SortState = JSON.stringify(sortState);
    reqBody.UserName = RestEndPoint.getCurrentUserName();
    reqBody.ViewName = currentScreen.screen.name;

    LeaseMasterChangeService.SaveUserProfile(reqBody)
    .then(response => window.toastr.success("Profile saved successfully."))
    .catch(error => {
      console.error(error.response);
      window.toastr.error("Unable to save profile");
    })
  }

  resetProfile = async () => {
    let reqBody = {};
    let currentScreen = this.getCurrentScreen();
    reqBody.UserName = RestEndPoint.getCurrentUserName();
    reqBody.ViewName = currentScreen.screen.name;

    await LeaseMasterChangeService.ResetUserProfile(reqBody)
    .then(response => window.toastr.success("Profile cleared successfully."))
    .catch(error => {
      console.error(error.response);
      window.toastr.error("Unable to reset profile");
    })
  }

  getProfile = async () => {
    var reqBody = {};
    let currentScreen = this.getCurrentScreen();
    reqBody.UserName = RestEndPoint.getCurrentUserName();
    reqBody.ViewName = currentScreen.screen.name;
    var ColumnState="", SortState="", FilterState = "";

    // Call to get User state
    await LeaseMasterChangeService.GetUserProfile(reqBody)
    .then(response => {
      if (response.data.length) {
      ColumnState = response.data[0].ColumnState ? response.data[0].ColumnState : "";
      SortState = response.data[0].SortState ? response.data[0].SortState : "";
      FilterState = response.data[0].FilterState ? response.data[0].FilterState : "";
    }})
    .catch(error => {
      console.error(error)
    });

    if(FilterState !== null && FilterState.length > 0)
      this.state.gridOptions.api.setFilterModel(JSON.parse(FilterState));
    if(ColumnState !== null && ColumnState.length > 0)
      this.state.gridOptions.columnApi.setColumnState(JSON.parse(ColumnState));
    if(SortState !== null && SortState.length > 0)
      this.state.gridOptions.api.setSortModel(JSON.parse(SortState));

    this.addMarketingRepGroup(this.state.userView!='MR');  
  }

  getCurrentScreen = () => {
    var screenName = this.props.path.split("/").pop();
    const { isDirectRoute } = this.state;
    if (isDirectRoute) {
      screenName = this.props.path.split("/")[1];
    }
    var currentScreen = this.props.CommonStore.screenDetails.find(
      (x) => x.screen.name === screenName
    );
    if (!currentScreen) {
      return {
        screen: { title: '', canEditRow: '', canCopyRow: '', canDeleteRow: '' },
        exportProfiles: '',
      }

    }
    return currentScreen;
  };

  getScreenData = async () => {
    const { isDirectRoute, userView } = this.state;
    const { CommonStore, LeaseMasterPriceChangeStore } = this.props;
    const currentScreen = this.getCurrentScreen();
    const jsonStringOBJ = sessionStorage.getItem('AUTH_TOKEN'); // This is the json string we stored
    const roleObj = JSON.parse(jsonStringOBJ);
    if (roleObj && roleObj.roles && currentScreen.screen.title && !isDirectRoute) {
      const { userName } = roleObj;
      this.setState({ loggedInUser: userName });
      const roles = roleObj.roles.join();
      const isSOXAuditMarketingRepRole = (roles.indexOf(userRoles.SOXMARKETINGREPRESENTATIVE) !== -1);
      const isSOXAuditPricingAdminRole = (roles.indexOf(userRoles.SOXAUDITPRICINGADMIN) !== -1);
      if (isSOXAuditPricingAdminRole)
        this.setState({ isSOXAuditPricingAdminRole: true})
      if (isSOXAuditMarketingRepRole) {
        this.setState({ isSOXAuditMarketingRepRole: true })
        await LeaseMasterPriceChangeStore.getScreenData(userName, currentScreen, CommonStore);
        await LeaseMasterPriceChangeStore.getMarketingRepList();
        this.filterViewData(userView);
        this.addMarketingRepGroup(userView!='MR');
        this.state.gridOptions.columnApi.autoSizeAllColumns();
      }
    }
  }

  refreshData = async () => {
    const { LeaseMasterPriceChangeStore } = this.props;
    const { loggedInUser, gridOptions } = this.state;
    const currentScreen = this.getCurrentScreen();
    await LeaseMasterPriceChangeStore.refreshScreenData({
      "userEmail": loggedInUser,
      "screenName": currentScreen.screen.name
    });
    if (gridOptions && gridOptions.api) {
      gridOptions.api.deselectAll();
      gridOptions.api.redrawRows();
    }
  };

  
}

export default LeaseMasterPriceChangeComponent;
